/**
    * (?!.*[,-]$) - Ensures that the string does not end with a comma or hyphen
    * (?!^[,-]) - Ensures that the string does not start with a comma, or hyphen
    * ([A-Za-z0-9,-]+) - Matches one or more alphanumeric characters or hyphens
 */

export const isStreetNumberFormat = (value: string) => /^(?!.*[,-]$)(?!^[,-])(.+)$/.test(value);
